import { useQuery } from '@tanstack/react-query';
import { getPrograms } from '../../api/me';
import { learnerKeys } from '../../pages/learner/DashboardPage';
import type { components } from '../../types/learnerApi';

type Program = components['schemas']['Program'];

export interface UseProgramsResult {
  programs: Program[];
  isLoading: boolean;
  isError: boolean;
}

export function usePrograms(): UseProgramsResult {
  const query = useQuery({
    queryKey: learnerKeys.programs,
    queryFn: getPrograms,
    staleTime: 30_000,
    retry: (count, err) => {
      const status = (err as { response?: { status?: number } })?.response?.status;
      return status !== 401 && status !== 403 && count < 2;
    },
  });

  return {
    programs: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
